import React from 'react';
import { specialistCareData } from '../data/mock';
import { Home, Brain, Sparkles } from 'lucide-react';

const careIcons = [
  Home,
  Brain,
  Sparkles
];

const SpecialistCareSection = () => {
  return (
    <section id="specialist-care" className="py-24 md:py-32 bg-[#1A2B3C]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-lato text-[#D4AF37] uppercase tracking-[0.3em] text-sm mb-4 block">Specialist Care</span>
          <h2 className="font-playfair text-4xl md:text-5xl text-white mb-4">Clinical Excellence</h2>
          <p className="font-lato text-white/60 max-w-2xl mx-auto">
            Our specialist pathways combine medical expertise with compassionate care,
            delivered in an environment of exceptional comfort.
          </p>
        </div>

        {/* Care Pillars */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-0 lg:gap-0 rounded-xl overflow-hidden">
          {specialistCareData.map((care, index) => {
            const IconComponent = careIcons[index];
            return (
              <div
                key={care.id}
                className={`relative p-10 ${
                  index === 1
                    ? 'bg-[#D4AF37] text-[#1A2B3C]'
                    : 'bg-[#243B4D] text-white'
                } group hover:bg-opacity-90 transition-all duration-500`}
              >
                {/* Icon */}
                <div className={`w-14 h-14 mb-6 rounded-full border-2 ${
                  index === 1
                    ? 'border-[#1A2B3C]/30'
                    : 'border-[#D4AF37]/30'
                } flex items-center justify-center`}>
                  <IconComponent className={`w-6 h-6 ${
                    index === 1 ? 'text-[#1A2B3C]' : 'text-[#D4AF37]'
                  }`} />
                </div>

                {/* Subtitle */}
                <span className={`font-lato text-sm tracking-wider uppercase mb-2 block ${
                  index === 1 ? 'text-[#1A2B3C]/60' : 'text-[#D4AF37]'
                }`}>
                  {care.subtitle}
                </span>

                {/* Title */}
                <h3 className="font-playfair text-2xl mb-4">
                  {care.title}
                </h3>

                {/* Description */}
                <p className={`font-lato text-sm leading-relaxed ${
                  index === 1 ? 'text-[#1A2B3C]/80' : 'text-white/70'
                }`}>
                  {care.description}
                </p>

                {/* Bottom accent line */}
                <div className={`absolute bottom-0 left-0 right-0 h-1 ${
                  index === 1
                    ? 'bg-[#1A2B3C]'
                    : 'bg-[#D4AF37]'
                } transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left`} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SpecialistCareSection;
